
import { IGridConfigItem, ITemplateConfig } from "../../../constants/interfaces";
import * as defaultTemplates from "./templates/templatesDefaultConfiguration";

/**
 * Default template id
 *
 * @return {number}
 */
export function getDefaultTemplateId() {
  return 1;
}

/**
 * Get list of available templates for dashboard
 *
 * @return {ITemplateConfig[]}
 */
export function getTemplates(): ITemplateConfig[] {
  return defaultTemplates.templates;
}

/**
 * Get default configuration for template
 *
 * @param id
 * @return {ITemplateConfig}
 */
export function getTemplateDefaultConfiguration(id: number | string): ITemplateConfig {
  const templateId = Number(id);
  let template = { gridConfig: []} as any
  template = {...getTemplates().find((template) => template.id === templateId)}

  template.grid_config = template.grid_config.map((item : any) => {
    return {...item};
  });

  return template;
}

/**
 * Returns default configuration for grid_config index
 *
 * @param templateId
 * @param itemId
 *
 * @return {IGridConfig}
 */
export function getTemplateCellDefaultConfiguration(templateId: number, itemId: number): IGridConfigItem {
  return { ...(getTemplates()[templateId - 1].grid_config[itemId] as IGridConfigItem) };
}